export class SmartphotoEstimation {
    taxValue;
    total = {
        pieces: 0,
        paint: {
            time: 0,
            cost: 0,
            materials: 0,
            total: 0
        },
        labour: {
            time: 0,
            cost: 0,
            total: 0
        },
        assembly: {
            time: 0,
            cost: 0
        },
        various: 0,
        consumable: 0,
        discount: 0,
        excess: 0,
        tax: {
            base: 0,
            cost: 0,
            total: 0
        },
        value: 0
    };
    constructor(taxValue, damages) {
        this.taxValue = taxValue;
        this.total = this.calculate(damages);
    }
    static getPercentage(total, amount, max, min) {
        const percent = (total * amount) / 100;
        return (percent > max && max) || (percent < min && min) || percent;
    }
    setVarious() {
        const { pieces, paint, labour, assembly } = this.total;
        this.total.various = pieces + paint.materials + [paint, labour, assembly].reduce((acc, { cost }) => acc + cost, 0);
    }
    setTax() {
        const { various, consumable, discount } = this.total;
        const base = various + consumable - discount;
        this.total.tax.base = base > 0 ? base : 0;
        const cost = (this.total.tax.base * this.taxValue) / 100;
        this.total.tax.cost = cost > 0 ? cost : 0;
        this.total.tax.total = this.total.tax.base + this.total.tax.cost;
        const value = this.total.tax.total - this.total.excess;
        this.total.value = value > 0 ? value : 0;
    }
    updateTaxValue(value) {
        this.taxValue = value;
    }
    calculate(damages) {
        const totalData = {
            pieces: 0,
            paint: {
                time: 0,
                cost: 0,
                materials: 0,
                total: 0
            },
            labour: {
                time: 0,
                cost: 0,
                total: 0
            },
            assembly: {
                time: 0,
                cost: 0
            },
            various: 0,
            consumable: 0,
            discount: 0,
            excess: 0,
            tax: {
                base: 0,
                cost: 0,
                total: 0
            },
            value: 0
        };
        this.total = damages
            .filter(({ estimation }) => !['discount', 'excess', 'consumable'].includes(estimation.operation ?? ''))
            .reduce((acc, { estimation }) => {
            const { piece, paint, labour, assembly } = estimation;
            // Increase totals
            acc.pieces += piece ?? 0;
            acc.paint.materials += paint.materials ?? 0;
            // Iterate to increase totals
            acc.paint.time += paint.time ?? 0;
            acc.paint.cost += paint.cost ?? 0;
            acc.labour.time += labour.time ?? 0;
            acc.labour.cost += labour.cost ?? 0;
            acc.assembly.time += assembly.time ?? 0;
            acc.assembly.cost += assembly.cost ?? 0;
            acc.paint.total = acc.paint.cost + acc.paint.materials;
            acc.labour.total = acc.labour.cost + acc.assembly.cost;
            return acc;
        }, { ...totalData });
        this.setVarious();
        this.total.consumable = damages
            .filter(({ estimation }) => ['consumable'].includes(estimation.operation ?? ''))
            .map(({ estimation }) => {
            const { value = {} } = estimation;
            const { type, amount = 0, max = 0, min = 0 } = value;
            return type === 'fixed' ? amount : SmartphotoEstimation.getPercentage(this.total.pieces, amount, max, min);
        })
            .reduce((a, b) => a + b, 0);
        this.total.excess = damages
            .filter(({ estimation }) => ['excess'].includes(estimation.operation ?? ''))
            .map(({ estimation }) => {
            const { value = {} } = estimation;
            const { type, amount = 0, max = 0, min = 0 } = value;
            return type === 'fixed' ? amount : SmartphotoEstimation.getPercentage(this.total.various, amount, max, min);
        })
            .reduce((a, b) => a + b, 0);
        this.total.discount = damages
            .filter(({ estimation }) => ['discount'].includes(estimation.operation ?? ''))
            .map(({ estimation }) => {
            const { value = {} } = estimation;
            const { type, amount = 0, max = 0, min = 0 } = value;
            const total = this.total.various + this.total.consumable;
            return type === 'fixed' ? amount : SmartphotoEstimation.getPercentage(total, amount, max, min);
        })
            .reduce((a, b) => a + b, 0);
        this.setTax();
        return this.total;
    }
}
